import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { ActivationEnd, Router } from '@angular/router';
import { HttpCancelService } from './http-cancel.service';
import { catchError, takeUntil, tap } from 'rxjs/operators';
import { AppService } from './app.service';

@Injectable()
export class ManageHttpRequestsInterceptor implements HttpInterceptor {


  constructor(router: Router,
    private httpCancelService: HttpCancelService,
    private appService: AppService) {
    router.events.subscribe(event => {
      // An event triggered at the end of the activation part of the Resolve phase of routing.
      if (event instanceof ActivationEnd) {
        // Cancel pending calls
        this.httpCancelService.cancelPendingRequests();
      }
    });
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    for (const url of this.httpCancelService.whiteListUrls) {
      if (request.url.startsWith(url)) {
        return next.handle(request);
      }
    }

    for (const [index, url] of this.httpCancelService.logoUrls.entries()) {
      if (request.url.startsWith(url)) {
        const authToken = localStorage.getItem('loggedInUser') ? JSON.parse(localStorage.getItem('loggedInUser')).Authorization : '';
        const reqClone = request.clone({
          method: request.method === 'POST' && (index === 0 || index === 2) ? 'PUT' : request.method,
          setHeaders: {
            'Authorization': authToken
          }
        });
        return next.handle(reqClone).pipe(
          takeUntil(this.httpCancelService.onCancelPendingRequests()),
          catchError((err): Observable<any> => {
            return this.handleError(err);
          }
          )
        );
      }
    }

    return next.handle(request).pipe(
      takeUntil(this.httpCancelService.onCancelPendingRequests()),
      catchError((err): Observable<any> => {
        return this.handleError(err);
      })
    );
  }

  handleError(err): Observable<any> {
    this.appService.notifyError();
    return throwError(err);
  }
}
